import React, { useState } from 'react';
import { Typography } from '../../../_shared/components/Typography/Typography';
import { Button } from '../../../_shared/components/Button/Button';
import { ReactComponent as InfoIcon } from '../../../_shared/assets/icons/info-icon.svg';
import { ReactComponent as PlusIcon } from '../../../_shared/assets/icons/plus.svg';
import { ReactComponent as PdfIcon } from '../../../_shared/assets/icons/pdf-icon.svg';
import { KpiTable } from '../../../_shared/components/KpiTable/KpiTable';
import { mockKpiItems } from '../../../_shared/mocks';
import { Card } from '../../../_shared/components/Card/Card';
import { KpiFormModal } from '../../../_shared/components/KpiFormModal/KpiFormModal';
import { KpiDetailModal } from '../../../_shared/components/KpiDetailModal/KpiDetailModal';
import { KpiItem } from '../../../_shared/types';
import { useKpeSelector } from '../../../_shared/store/store';
import { KpiDeleted } from '../../components/KpiDeleted/KpiDeleted';
import styles from './EmployeeView.module.scss';

export function EmployeeView() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedKpi, setSelectedKpi] = useState<KpiItem | null>(null);
  const hasKpi = useKpeSelector((s) => s.kpe.hasKpi);
  const hasDeletedKpi = useKpeSelector((s) => s.kpe.hasDeletedKpi);

  return (
    <div className={styles.view}>
      <div className={styles.section}>
        <div className={styles.head}>
          <div className={styles.headInfo}>
            <Typography variant="h2">Мои КПЭ</Typography>
            <Typography variant="text">
              КПЭ помогают зафиксировать приоритеты на год и сделать результат
              измеримым. Рекомендуется задать от 3 до 7 показателей.
              <br />
              По итогам выполнения показателей рассчитывается уровень
              эффективности и размер премии.
            </Typography>
          </div>
          <Button
            className={styles.pdfBtn}
            variant={'secondary'}
            onClick={() => alert('Скачать PDf')}
          >
            Скачать <PdfIcon />
          </Button>
        </div>

        {!hasKpi && (
          <Card>
            <div className={styles.emptyBlock}>
              <InfoIcon className={styles.infoIcon} />
              <div className={styles.emptyContent}>
                <Typography variant="h5">
                  Сформируйте план КПЭ на год
                </Typography>
                <Typography className={styles.emptyText} variant="text">
                  Укажите плановые значения, методику расчёта и ответственные
                  подразделения.
                  <br />
                  Вы можете изменить показатели и согласовать их с
                  руководителем.
                </Typography>
                <Button
                  className={styles.emptyExampleBtn}
                  variant="disabled"
                  onClick={() => alert('Пример таблицы')}
                >
                  Пример таблицы
                </Button>
              </div>
            </div>
            <Button
              className={styles.emptyAddBtn}
              variant="secondary"
              onClick={() => setIsModalOpen(true)}
            >
              Добавить KPI&nbsp;{' '}
              <span>
                <PlusIcon />
              </span>
            </Button>
          </Card>
        )}

        {hasKpi && (
          <Card className={styles.tableContent}>
            <KpiTable
              rows={mockKpiItems}
              editable
              onKpiClick={(row) => setSelectedKpi(row as KpiItem)}
              onEdit={(row) => console.log('edit', row)}
              onDelete={(row) => console.log('delete', row)}
            />

            {hasDeletedKpi && (
              <KpiDeleted
                rows={mockKpiItems}
                isDeleted={true}
                onKpiClick={(row) => setSelectedKpi(row as KpiItem)}
              />
            )}
            <div className={styles.actions}>
              <Button
                className={styles.actionAdd}
                variant="secondary"
                onClick={() => setIsModalOpen(true)}
              >
                Добавить KPI&nbsp;{' '}
                <span>
                  <PlusIcon />
                </span>
              </Button>
              <Button
                className={styles.actionSend}
                variant="primary"
                onClick={() => alert('Отправить на согласование')}
              >
                Отправить на согласование
              </Button>
            </div>
          </Card>
        )}
      </div>

      <KpiFormModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={(values) => console.log('submit', values)}
        notification={'Текст возможного уведомления'}
      />

      <KpiDetailModal
        isOpen={!!selectedKpi}
        isEditing={false}
        onClose={() => setSelectedKpi(null)}
        kpi={selectedKpi}
      />
    </div>
  );
}
